<template>
  <div class="requests requests-view">
    <projects-requests-header :inRequestedStatus="requestedRequests"> </projects-requests-header>
    <wombat-table
      class="requests-table"
      :items="formattedRequest"
      :columns="tableColumns"
      :resize="false"
      :loadingItems="false"
      :columnsReorder="false"
      :itemHeight="58"
      :noResultsMessage="$t('noResultsFound')"
      @columnSorted="columnSorted"
    >
      <component
        slot="row-cell"
        slot-scope="rowCell"
        :is="tableRowCellComponentsHash[rowCell.column.name] || tableRowCellComponentsHash.default"
        :item="rowCell.item"
        :column="rowCell.column"
        class="row-cell"
      ></component>
    </wombat-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { requestsColumns, getEmptyColumn } from '@/services/tableColumns';
import { CHANGE_REQUESTS_LIST_OPTIONS } from '@/store/request/actionTypes';

import store from '@/store';
import WombatTable from '@/components/WombatTable/WombatTable.vue';
import WombatRowDefaultCell from '@/components/WombatTable/WombatRowDefaultCell.vue';
import { numberWithPeriods } from '@/utils/numberUtils';
import ProjectsRequestsHeader from '@/components/ProjectsRequestsHeader/ProjectsRequestsHeader.vue';
import RequestDeclineApproveTableCell from '@/components/tableCells/RequestDeclineApproveTableCell.vue';
import { formatEndDate, formatStartDate } from '@/utils/dateUtils';
import { numberOfRequestsWithRequestsStatus } from '@/utils/requestUtils';
import { SET_NEW_PROJECT, SET_NEW_PROJECT_NAVIGATION } from '@/store/newProject/actionTypes';
import { emptyProject, initNewProjectNavigation } from '@/constants/projects';

export default {
  name: 'RequestsList',
  components: {
    WombatTable,
    WombatRowDefaultCell,
    ProjectsRequestsHeader,
    RequestDeclineApproveTableCell,
  },
  computed: {
    ...mapGetters(['requests', 'requestListSort']),
    tableColumns() {
      const columns = [
        requestsColumns.projectNumber,
        requestsColumns.projectType,
        requestsColumns.projectStart,
        requestsColumns.projectEnd,
        requestsColumns.projectBudget,
        requestsColumns.declineApprove,
      ].map(column => ({
        ...column,
        title: column.title && this.$t(column.title),
        sort: this.requestListSort[column.sortingField || column.field],
      }));

      return [getEmptyColumn(32), ...columns, getEmptyColumn(85)];
    },
    tableRowCellComponentsHash() {
      return {
        declineApprove: RequestDeclineApproveTableCell,
        default: WombatRowDefaultCell,
      };
    },
    formattedRequest() {
      return this.requests.map(request => ({
        ...request,
        projectNumber: request.project.projectNumber,
        formattedType: this.$t(`project.type.${request.project.type}`),
        formattedStartDate: formatStartDate(request.project.startDate),
        formattedEndDate: formatEndDate(request.project.endDate),
        formattedBudget: `$${numberWithPeriods(request.project.budget)}`,
      }));
    },
    requestedRequests() {
      return numberOfRequestsWithRequestsStatus(this.requests);
    },
  },
  async mounted() {
    await store.dispatch(SET_NEW_PROJECT, _.cloneDeep(emptyProject));
    await store.dispatch(SET_NEW_PROJECT_NAVIGATION, _.cloneDeep(initNewProjectNavigation));
  },
  methods: {
    columnSorted({ column, direction }) {
      this.$store.dispatch(CHANGE_REQUESTS_LIST_OPTIONS, {
        sort: direction
          ? {
            [column.sortingField || column.field]: direction,
          }
          : {},
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
